<template>
  <section id="dept-tree">
    <el-row :gutter="24">
      <el-col
        :span="model == 'org' || model == 'org_group' ? 24 : 12"
        class="left"
      >
        <el-tree
          ref="tree"
          :props="defaultProps"
          :load="loadNode"
          lazy
          node-key="id"
          @check-change="checkChange"
          @node-click="getUser"
          :expand-on-click-node="false"
          :show-checkbox="
            model == 'org' ||
              model == 'both' ||
              model == 'bothAll' ||
              model == 'org_group'
          "
          :check-strictly="true"
          :check-on-click-node="model == 'org' || model == 'org_group'"
          :default-expand-all="false"
          empty-text="暂无数据"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <img class="tag-ava" :src="'img/org.png'" />
            <span>{{ data.name }}</span>
          </span>
        </el-tree>
      </el-col>
      <el-col
        :span="12"
        style="border-left: 1px solid #eee;"
        v-if="!(model == 'org' || model == 'org_group')"
      >
        <div class="right">
          <UserList
            :userList.sync="userList"
            :loadingUser.sync="loadingUser"
            :hasClick.sync="hasClick"
            :showPhone="showPhone"
            @change="change"
          />
        </div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import UserList from "./userList.vue";
import qs from "querystring";
import lodash from "lodash";
// import url from "./this.url.js";

export default {
  props: ["chosen", "model", "max", "showPhone", "url"],
  components: {
    UserList
  },
  data() {
    return {
      defaultProps: {
        label: "name",
        children: "child",
        isLeaf: "has_child"
      },
      initTreeData: [],
      userList: [],

      activeDept: 0,
      tmpChosen: this.chosen,
      loadingUser: false,
      hasClick: false,
      deptListIds: []
    };
  },
  methods: {
    // 獲取節點方法
    loadNode(node, resolve) {
      if (node.level === 0) {
        this.getTree(data => {
          this.initTreeData = data;
          return resolve(data);
        });
      }
      if (node.level === 1) {
        const childId = node.data.id;
        let child = [];
        this.initTreeData.forEach(item => {
          if (childId == item.id) {
            child = item.child;
            this.basepaName = item["name"];
            child.forEach(item1 => {
              item1.has_child = Number(item1.has_child) === 1 ? false : true;
            });
          }
        });
        return resolve(this.setLeaf(child));
      }
      if (node.level > 1) {
        if (!node.data.has_child) {
          this.getTreeOver2(node.data, data => {
            return resolve(data);
          });
        } else {
          return resolve([]);
        }
      }
      // if (node.level === 3) {
      //   return resolve([]);
      // }
      // this.updateTreeChecked()
    },
    // 獲取根樹
    async getTree(cb) {
      let lv1Res = await this.$common.http({
        url: this.url.getDeptTop
      });

      let data = lv1Res.data.data;
      for (let i = 0; i < data.length; i++) {
        data[i].disabled = !Number(data[i].enable_r);
        this.deptListIds.push(data[i].id);
        if (data[i].child && data[i].child.length > 0) {
          for (let j = 0; j < data[i].child.length; j++) {
            this.deptListIds.push(data[i].child[j].id);
            data[i].child[j].disabled = !Number(data[i].child[j].enable_r);
          }
        }
      }
      cb(data);
      //   this.$common.lock();
      //   this.$common.reqSP(this.url.getDeptTop, {}, res => {
      //     this.$common.unlock();
      //     // res.data.data.child = res.data.data.child
      //     let data = [res.data.data];
      //     for (let i = 0; i < data.length; i++) {
      //       data[i].disabled = !Number(data[i].enable_r);
      //       for (let j = 0; j < data[i].child.length; j++) {
      //         data[i].child[j].disabled = !Number(data[i].child[j].enable_r);
      //       }
      //     }
      //     cb(data);
      //   });
    },
    // 獲取超過2層的樹
    async getTreeOver2(obj, cb) {
      let lv2Res = await this.$common.http({
        url: this.url.getDept,
        data: {
          department_id: obj.id,
          name: obj.name,
          level: obj.lev
        }
      });
      let data = lv2Res.data.data;
      for (let i = 0; i < data.length; i++) {
        this.deptListIds.push(data[i].id);
        data[i].disabled = !Number(data[i].enable_r);
        data[i].has_child = Number(data[i].has_child) === 1 ? false : true;
      }
      cb(this.setLeaf(data));
      // this.$common.lock();
      // this.$common.reqSP(
      //   this.url.getDept,
      //   qs.stringify({
      //     department_id: obj.id,
      //     name: obj.name,
      //     level: obj.lev
      //   }),
      //   res => {
      //     this.$common.unlock();
      //     let data = res.data.data;
      //     for (let i = 0; i < data.length; i++) {
      //       data[i].disabled = !Number(data[i].enable_r);
      //       data[i].has_child = Number(data[i].has_child) === 1 ? false : true;
      //     }
      //     cb(this.setLeaf(data));
      //   }
      // );
    },
    // 設置是否為葉子還是樹枝
    setLeaf(arr) {
      for (var index in arr) {
        if (arr[index].isParent) {
          arr[index].leaf = false;
        } else {
          arr[index].leaf = true;
        }
      }
      return arr;
    },
    // 獲取人員
    getUser(obj) {
      if (obj.enable_r !== 0) {
        this.getUserByDeptId(obj.id);
      }
    },
    // 根據id獲取人員
    getUserByDeptId(id) {
      if (this.activeDept === id) {
        return false;
      }
      this.hasClick = true;
      this.loadingUser = true;
      this.activeDept = id;
      this.userList = [];

      this.$common
        .http({
          url: this.url.getUserByDeptId,
          data: { department_id: id, offset: 0, limit: 999999, type: 2 },
          noLoading: true
        })
        .then(res => {
          console.log(qs.stringify({ dept_id: id }));
          this.loadingUser = false;
          this.userList = res.data.data.items;
          this.updateChecked("user");
        });
      // this.$common.reqSP(
      //   this.url.getUserByDeptId,
      //   qs.stringify({ department_id: id, offset: 0, limit: 999999, type: 2 }),
      //   res => {
      //     console.log(qs.stringify({ dept_id: id }));
      //     this.loadingUser = false;
      //     this.userList = res.data.data.items;
      //     this.updateChecked("user");
      //   }
      // );
    },
    // 分組和人員選中或者取消選中
    change(data, type) {
      // debugger;
      if (data.checked) {
        if (this.max && Object.keys(this.tmpChosen[type]) + 1 > this.max) {
          this.$common.error("最多只能選擇" + this.max + "個選項!");
        } else {
          if (typeof this.tmpChosen[type] != "object") {
            this.tmpChosen[type] = {};
          }
          this.tmpChosen[type][data.id] = data;
        }
      } else {
        delete this.tmpChosen[type][data.id];
      }
      this.tmpChosen = this.$common.deep(this.tmpChosen);
    },
    // 更新選擇狀態
    updateChecked(type) {
      const listName = type + "List";
      const list = this[listName];
      for (let index in list) {
        const targ = this.chosen[type];
        list[index].checked = Boolean(targ && targ[list[index].id]);
      }
      this[type + "List"] = this.$common.deep(list);
    },
    // 更新樹的checkbox的選中
    updateTreeChecked() {
      let arr = [];
      if (this.tmpChosen.org) {
        for (let deptId in this.tmpChosen.org) {
          arr.push(deptId);
        }
      }
      this.$refs.tree.setCheckedKeys(arr);
    },
    checkChange() {
      // 选择的结果
      let list = this.$refs.tree.getCheckedNodes();
      let listIds = [];
      list.forEach(item => {
        listIds.push(item.id);
      });

      // 当前所有结果
      let resultIds = Object.keys(this.tmpChosen["org"]);

      console.log(this.deptListIds, listIds, resultIds);
      // 树结果是否在所有结果中listIds,resultIds(删除)，否者增加
      let isAdd = lodash.difference(listIds, resultIds);
      if (isAdd.length === 0) {
        //包含删除数组
        let cDelArr = lodash.intersection(resultIds, this.deptListIds);
        let isDelArr = lodash.difference(cDelArr, listIds);
        let isDel = isDelArr[0];
        delete this.tmpChosen["org"][isDel];
      } else {
        //增加
        let addObj = {};
        list.forEach(item => {
          if (item.id == isAdd[0]) {
            addObj = item;
          }
        });
        this.tmpChosen["org"][addObj.id] = addObj;
      }

      // this.tmpChosen["org"] = {};
      // for (let index in list) {
      //   this.tmpChosen["org"][list[index].id] = list[index];
      // }
      this.tmpChosen = this.$common.deep(this.tmpChosen);
    }
  },
  watch: {
    chosen: function(val) {
      this.tmpChosen = val;
      this.updateChecked("user");
      this.updateTreeChecked();
    },
    tmpChosen: {
      deep: true,
      handler: function(val) {
        this.$emit("updateChosen", val);
      }
    }
  },
  mounted() {
    this.updateTreeChecked();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
#dept-tree {
  overflow-y: auto;
  overflow-x: hidden;
  .el-tree-node__content {
    position: relative;
    .el-checkbox {
      position: absolute;
      right: 0;
    }
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    border: 1px solid #aaa;
  }
  .el-checkbox__inner::after {
    top: 2px;
    left: 5px;
  }
  .left,
  .right {
    padding: 0 15px;
    height: 225px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
